import { Button, type ButtonProps } from '@mui/material';
import React from 'react';

interface SpaceGradientButtonProps extends Omit<ButtonProps, 'variant'> {
    children: React.ReactNode;
    size?: 'small' | 'medium' | 'large';
}

export default function SpaceGradientButton({ children, sx, size = 'medium', ...props }: SpaceGradientButtonProps) {
    return (
        <Button
            variant="contained"
            size={size}
            sx={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                '&:hover': {
                    background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                },
                '&:disabled': {
                    background: 'linear-gradient(135deg, #cccccc 0%, #999999 100%)',
                    color: 'rgba(255, 255, 255, 0.5)',
                },
                ...sx,
            }}
            {...props}
        >
            {children}
        </Button>
    );
}
